import React from 'react';
import { useSelector } from 'react-redux';

const Heading = () => {
    const { dimension } = useSelector(state => state.carromm);

    const resetDimension = () => {
        window.location.reload();
    };

    return (
        <div style={{display:"flex",justifyContent:"space-between"}}>
            <div>
                <h2
                    className="upload-modal-title">
                    {`picDesigner - ${dimension} Showrooms`}
                </h2>
                <p
                    className="upload-modal-description">
                    Professionelle Aufnahmen mit wenigen Klicks
                </p>
            </div>
            <div>
                <button onClick={() => resetDimension()} class="btn-primary">Neu starten</button>
            </div>
        </div>
    )
}

export default Heading